module.exports = __webpack_public_path__ + "static/media/ic_support_inactive.e035be43.svg";